<template>
  <el-dialog
    v-if="dialogSwitch"
    :visible.sync="dialogSwitch"
    :close-on-click-modal="false"
    class="dialogBox"
    width="550px"
    :show-close="false"
    :modal-append-to-body="false">
    <svg class="closeIcon cursor" aria-hidden="true" @click="dialogSwitch = false">
      <use xlink:href="#icon-a-Property1shibai" />
    </svg>
    <h3 class="messageTitle">报错页面示例</h3>
    <div class="messageContent">
      <div class="imgBox">
        <img src="../../../../../assets/img/console/404.jpg" alt="">
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogSwitch:false,
  
    };
  },
  created(){
  
  },
  methods: {
    show() {
      this.dialogSwitch = true;
    },

  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
    .el-dialog__header{
      // display: none;
    }
  }
  
  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 30px;
    height: 30px;
  }
  .messageTitle {
    position: relative;
    margin-bottom: 40px;
    font-size: 20px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
  }
  .messageContent {
    padding: 0 50px;   
    font-size: 16px;
    width: 500px;
    height: 700px;
    .imgBox{
      width:100% ;
      height: 100%;
      img{
       width:100% ;
      height: 100%; 
      }
    }
  }
}

</style>
